var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.048 987.288c-215.78 0 -386.89 -126.3 -465.782 -306.357 -87.697 -200.147 -17.683 -521.252 138.959 -662.986l-6.097 156.546c8.164 -9.882 67.73 -12.561 77.453 .105 31.885 -61.772 136.332 -108.113 220.25 -109.595 -31.945 26.522 -105.735 124.029 -99.119 174.06 40.665 12.516 103.146 13.079 135.984 15.301 9.958 5.477 8.399 39.996 -11.841 67.826 -26.407 36.313 -97.068 49.037 -97.068 49.037l8.255 105.653 -77.525 -37.466c-25.128 63.237 35.209 119.914 97.917 109.186 68.926 -11.793 93.463 -56.786 141.913 -53.975 48.451 2.812 67.447 29.354 61.052 54.574 -7.578 29.891 -59.923 25.082 -59.923 25.082 -43.82 69.865 -102.32 100.261 -197.361 92.19 144.26 119.076 338.109 10.923 387.239 -86.49 49.13 -97.413 6.431 -241.501 -43.041 -282.588 58.224 24.922 98.508 50.963 119.421 107.063 11.498 -124.9 -46.205 -266.608 -148.991 -349.612 193.178 56.003 311.039 205.701 314.342 444.666 3.304 238.964 -211.469 487.779 -496.037 487.779z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.de831553518d0b81c58299e1c897bff6.svg";
export { ForwardRef as ReactComponent };